<template>
  <div id="app">
    <div class="main-nav-position">
      <Navbar />
    </div>
    <div class="main-body">
      <router-view/>
    </div>
    <FooterBottom />
  </div>
</template>

<script>
import Navbar from './components/navbar/Navbar'
import FooterBottom from './components/footer/FooterBottom'

export default {
  components: {
    Navbar,
    FooterBottom,
  },
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Signika:400,700&display=swap');

  // Import custom SASS variable overrides
  @import 'assets/custom.scss';
  // Import Bootstrap and BootstrapVue source SCSS files
  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/src/index.scss';

  #app {
    font-family: 'Signika', sans-serif;
    background: var(--white);
    color: var(--blue);
    font-size: 1.25em;
    overflow-x: hidden;
  }

  .main-nav-position {
    z-index: 4;
    position: absolute;
    top: 0;
    left:0;
    width: 100%;
  }
  .main-body {
    z-index: 1;
  }

  .full-view {
    min-height: 100vh;
  }

  .pink-text {
    color: var(--red);
  }
  .blue-text {
    color: var(--blue);
  }

  h1 {
  text-transform: uppercase;
  font-size: 2.5rem;
  line-height: 1.25;
  font-weight: 700;
  }

  h2 {
    font-weight: 700;
    text-transform: uppercase;
    color: var(--red);
    font-size: 1.6rem;
  }

  h3 {
    font-weight: 400;
    font-size: 24px;
    line-height: 1.2;
  }

  h4 {
    color: var(--red);
    text-transform: uppercase;
    font-size: 1.125rem;
  }

  #Layer_1 {
    width:32px;
    height: auto;
  }

  .form-control {
    border: none;
    border-radius: 0;
    border-bottom: 2px solid var(--red);
    color: var(--red);
  }

  .form-control:focus{
    border-color: var(--red);
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .small-text {
    font-size: .7em;
    color: var(--gray);
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  a:hover {
    color: var(--red);
  }
  span {
    font-size: inherit;
  }

  @media (min-width: 1200px) {
    h2{
      font-size: 2rem;
    }
  }
</style>
